<template>
  <span class="tw-px-2 tw-text-gray-300">|</span>
</template>

<script>
export default {
  name: "LegendSeparator",
};
</script>
